import Link from 'components/links/Link';
import { NextSeo } from 'next-seo';
import React from 'react';

import Button from '../components/buttons/Button';
import Footer from '../components/Footer';
import SwitchToggle from '../components/inputs/SwitchToggle';
import pages from '../config/pages';
import useCookies from 'hooks/useCookies';

function CookiesPage() {
    const { changeCookiePreferences, cookiePreferences } = useCookies();

    const handleAgreementChange = (checked, type) => {
        changeCookiePreferences({ ...cookiePreferences, [type]: checked });
    };

    const handleActivateAll = () => {
        changeCookiePreferences({ advertising: true, analytics: true });
    };

    const handleRemoveAgreement = () => {
        changeCookiePreferences();
    };

    return (
        <div className="single-page pt-12 " id="cookies">
            <NextSeo title={pages.cookies.title} />

            <div className="container space-y-2 max-w-4xl">
                <h1 className="text-uppercase text-brand mb-8">Piškotki na portalu Kam za vikend</h1>

                <p>
                    HUDDA d.o.o. na spletnem portalu{' '}
                    <a href="http://www.kamavikend.si" className="text-brand">
                        www.kamavikend.si
                    </a>{' '}
                    uporablja piškotke. Uporaba piškotkov je podrobneje opredeljena v tej politiki piškotkov, kjer
                    najdete informacije o piškotkih, ki jih uporabljamo, njihovi funkciji ter času trajanja. Prav tako v
                    tej politiki piškotkov najdete informacije o možnosti nastavitev piškotkov na spletnem portalu.
                </p>
                <p>
                    Za obdelavo osebnih podatkov, ki ni vezana na uporabo piškotkov, si preberite našo politiko
                    zasebnosti, ki vam je na voljo{' '}
                    <a
                        href="https://kamzavikend.si/pdf/politika-zasebnosti.pdf"
                        target="_blank"
                        rel="noreferrer"
                        className="text-brand"
                    >
                        tukaj
                    </a>
                    .
                </p>
                <p>
                    Upravljavec osebnih podatkov je podjetje HUDDA d.o.o., Trg komandanta Staneta 8, 1000 Ljubljana. Za
                    kakršnakoli vprašanja glede uporabe piškotkov nas lahko kadarkoli kontaktirate po e-pošti na:{' '}
                    <a href="mailto:info@kamzavikend.si" className="text-brand">
                        info@kamzavikend.si
                    </a>
                </p>
                <h2>Kaj so piškotki?</h2>
                <p>
                    Piškotki so majhne besedilne datoteke, ki se ob obisku določene spletne strani naložijo na napravo
                    uporabnika. Piškotki opravljajo različne funkcije, nekateri zagotavljao delovanje posamične spletne
                    strani in izboljšajo uporabniško izkušnjo. Nekateri piškotki analizirajo promet na spletni strani,
                    drugi pa omogočajo izvajanje oglaševanja. Podrobneje vrste piškotkov in njihove funkcionalnosti
                    opredeljujemo spodaj.
                </p>
                <h2>Katere piškotke uporabljamo?</h2>
                <p>
                    Na naši spletni strani,{' '}
                    <a href="http://www.kamzavikend.si" className="text-brand">
                        www.kamzavikend.si
                    </a>{' '}
                    uporabljamo naslednje piškotke:
                </p>
                <ul className="list-disc pl-4">
                    <li>Nujni piškotki,</li>
                    <li>Analitični piškotki,</li>
                    <li>Oglaševalski piškotki.</li>
                </ul>
                <p>
                    <strong>Nujni piškotki</strong> so piškotki, ki zagotavljajo varnost in delovanje naše spletne
                    platforme. Brez teh piškotkov naša platforma ne deluje, zato jih ni mogoče izključiti. Te piškotki
                    vas ne morejo identificirati, saj je njihova naloga le pravilno prikazovanje spletne platforme.
                </p>
                <p>
                    <strong>Analitični piškotki</strong> so piškotki, ki omogočajo izvedbo statističnih analiz spletnih
                    strani. Z uporabo teh piškotkov lahko izdelamo analizo uporabe naše spletne platforme in s tem lažje
                    in bolj učinkovito izboljšamo vašo uporabniško izkušnjo. Te piškotke bomo uporabljali samo na
                    podlagi vašega soglasja.
                </p>
                <p>
                    <strong>Oglaševalski piškotki</strong> so piškotki, ki omogočajo kreiranje uporabniškega profila, na
                    podlagi katerega se uporabniku prikazujejo oglasna sporočila, ki so skladna z njegovimi interesi in
                    zanimanji. Na ta način želimo izboljšati vašo uporabniško izkušnjo. Te piškotke bomo uporabljali
                    samo na podlagi vašega soglasja. V kolikor se odločite, da ne želite uporabe oglaševalskih
                    piškotkov, to ne bo preprečilo pojava oglasov, temveč zgolj vplivalo na relevantnost oglasov glede
                    na vaša zanimanja.
                </p>
                <h2>Nameni obdelave osebnih podatkov</h2>
                <p>Piškotke lahko uporabljamo za različne namene, ki so opredeljeni spodaj.</p>
                <p>Na naši spletni strani uporabljamo piškotke za:</p>
                <ul>
                    <li>delovanje spletne strani;</li>
                    <li>izvajanje analiz spletnega mesta;</li>
                    <li>izvajanje prilagojenega oglaševanja.</li>
                </ul>
                <h2>Kako nastavite piškotke?</h2>
                <p>
                    V primeru, da ste na naši spletni strani prvič, imate možnost piškotke urediti v pasici, ki se
                    nahaja na dnu spletne strani. Na ta način lahko nastavitie piškotke, ki jih želite.
                </p>
                <p>
                    V kolikor želite nastavljeno ureditev piškotkov spremeniti, lahko to vedno uredite na naši spletni
                    strani:{' '}
                    <a href="http://www.kamzavikend.si" className="text-brand">
                        www.kamzavikend.si
                    </a>{' '}
                    in sicer v posameznem brskalniku. V kolikor na svoji napravi uporabljate več različnih brskalnikov
                    ali pa uporabljate različne naprave, je potrebno piškotke urediti za vsako napravo in brskalnik
                    ločeno.
                </p>
                <p>
                    Za pomoč pri nastavitvah vam spodaj podajamo linke do navodil za nastavitev v posameznem brskalniku:
                </p>
                <ul>
                    <li>
                        <Link
                            to="https://support.google.com/chrome/answer/95647?co=GENIE.Platform%3DDesktop&amp;hl=en"
                            target="_blank"
                            styles="text-brand"
                        >
                            Chrome
                        </Link>
                    </li>
                    <li>
                        <Link
                            to="https://support.mozilla.org/en-US/kb/clear-cookies-and-site-data-firefox"
                            target="_blank"
                            styles="text-brand"
                        >
                            Firefox
                        </Link>
                    </li>
                    <li>
                        <Link
                            to="https://support.microsoft.com/en-us/help/17442/windows-internet-explorer-delete-manage-cookies"
                            target="_blank"
                            styles="text-brand"
                        >
                            Internet Explorer
                        </Link>
                    </li>
                    <li>
                        <Link
                            to="https://support.apple.com/sl-si/guide/safari/sfri11471/mac"
                            target="_blank"
                            styles="text-brand"
                        >
                            Safari
                        </Link>
                    </li>
                </ul>
                <h2>Vaše pravice</h2>
                <p>
                    Pravice, ki jih imate glede obdelave osebnih podatkov, so opredeljene v naši politiki zasebnosti, do
                    katere lahko dostopate{' '}
                    <a
                        href="https://kamzavikend.si/pdf/politika-zasebnosti.pdf"
                        className="text-brand"
                        target="_blank"
                        rel="noreferrer"
                    >
                        tukaj
                    </a>
                    .
                </p>
                <h2>Spremembe</h2>
                <p>
                    Politika piškotkov se lahko kadarkoli spremeni, brez predhodnega opozorila. V kolikor bo potrebno
                    pridobiti vaše soglasje, vas bomo o tem predhodno obvestili. Veljavna različica politike piškotkov
                    je vedno na voljo na: kamzavikend.si/piskotki
                </p>
                <h2>Povzetek piškotkov</h2>
                <div className="max-w-full overflow-x-auto">
                    <table className="table-auto">
                        <tbody>
                            <tr>
                                <td className="border border-gray-300 p-2">
                                    <p>
                                        <strong>Ime piškotka</strong>
                                    </p>
                                </td>
                                <td className="border border-gray-300 p-2">
                                    <p>
                                        <strong>Veljavnost</strong>
                                    </p>
                                </td>
                                <td className="border border-gray-300 p-2">
                                    <p>
                                        <strong>Namen</strong>
                                    </p>
                                </td>
                                <td className="border border-gray-300 p-2">
                                    <p>
                                        <strong>Lastni piškotek? Piškotek tretjih oseb</strong>
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td className="border border-gray-300 p-2">
                                    <p>_ga</p>
                                </td>
                                <td className="border border-gray-300 p-2">
                                    <p>2 leti</p>
                                </td>
                                <td className="border border-gray-300 p-2 min-w-[150px]">
                                    <p>
                                        Piškotek orodja Google Analytics, ki nam pomaga pri izvajanju anonimnih
                                        statističnih analiz.
                                    </p>
                                </td>
                                <td className="border border-gray-300 p-2">
                                    <p>Piškotek tretje osebe</p>
                                </td>
                            </tr>
                            <tr>
                                <td className="border border-gray-300 p-2">
                                    <p>_ga_5QXPQ466C6</p>
                                </td>
                                <td className="border border-gray-300 p-2">
                                    <p>2 leti</p>
                                </td>
                                <td className="border border-gray-300 p-2 min-w-[150px]">
                                    <p>
                                        Piškotek orodja Google Analytics, ki nam omogoča anonimno zbiranje podatkov o
                                        sejah na spletni strani.
                                    </p>
                                </td>
                                <td className="border border-gray-300 p-2">
                                    <p>Piškotek tretje osebe</p>
                                </td>
                            </tr>
                            <tr>
                                <td className="border border-gray-300 p-2">
                                    <p>_fbc</p>
                                </td>
                                <td className="border border-gray-300 p-2">
                                    <p>2 meseca</p>
                                </td>
                                <td className="border border-gray-300 p-2 min-w-[150px]">
                                    <p>
                                        Piškotek orodja Facebook Pixel, ki nam pomaga pri beležnju obiska iz družbenega
                                        omrežja Facebook
                                    </p>
                                </td>
                                <td className="border border-gray-300 p-2">
                                    <p>Piškotek tretje osebe</p>
                                </td>
                            </tr>
                            <tr>
                                <td className="border border-gray-300 p-2">
                                    <p>_fbp</p>
                                </td>
                                <td className="border border-gray-300 p-2">
                                    <p>2 meseca</p>
                                </td>
                                <td className="border border-gray-300 p-2">
                                    <p>
                                        Piškotek orodja Facebook Pixel, ki unikatno določa spletno stran na kateri je
                                        nameščen.
                                    </p>
                                </td>
                                <td className="border border-gray-300 p-2">
                                    <p>Piškotek tretje osebe</p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div>
                    <div id="nastavitve" className="pt-8">
                        <h2 className="mb-2 text-brand">NASTAVITVE PIŠKOTKOV</h2>
                    </div>
                </div>

                <table className="table-auto">
                    <tbody>
                        <tr>
                            <td className="border border-gray-300 p-2">
                                <p>
                                    <strong>NUJNI piškotki </strong>
                                    omogočajo delovanje naše spletne platforme, zato jih ni mogoče izključiti.
                                </p>
                            </td>
                            <td className="border border-gray-300 p-2">
                                <p>
                                    <strong>VEDNO AKTIVNO</strong>
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td className="border border-gray-300 p-2">
                                <p>
                                    <strong>ANALITIČNI piškotki</strong> zbirajo podatke o obiskih in uporabi naše
                                    spletne platforme.
                                </p>
                            </td>
                            <td className="border border-gray-300 p-2">
                                <SwitchToggle
                                    enabled={!!cookiePreferences?.analytics}
                                    onChange={(checked) => handleAgreementChange(checked, 'analytics')}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td className="border border-gray-300 p-2">
                                <p>
                                    <strong>OGLAŠEVALSKI piškotki</strong> nam omogočajo zbiranje podatkov o vas in
                                    izgradnjo uporabniškega profila, na podlagi katerega vam lahko ponudimo oglase, ki
                                    so prilagojeni vašim željam in interesom.
                                </p>
                            </td>
                            <td className="border border-gray-300 p-2">
                                <SwitchToggle
                                    enabled={!!cookiePreferences?.advertising}
                                    onChange={(checked) => handleAgreementChange(checked, 'advertising')}
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>

                <div className="flex justify-between">
                    <div className="mt-4">
                        <Button onClick={handleRemoveAgreement} variant="text" color="secondary">
                            Deaktiviraj piškotke
                        </Button>
                    </div>

                    <div className="mt-4">
                        <Button onClick={handleActivateAll}>Aktiviraj piškotke</Button>
                    </div>
                </div>
            </div>

            <div className="mt-24">
                <Footer />
            </div>
        </div>
    );
}

export default CookiesPage;
